var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "ItpBox",
        { staticClass: "items-spacing w-100", attrs: { alignItems: "center" } },
        [
          _c(
            "ItpBox",
            { attrs: { direction: "column" } },
            [
              _c(
                "ItpBox",
                [
                  _c("ItpText", { staticClass: "mb-0", attrs: { muted: "" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.config.resourceTitle) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.payment.transaction_type
                    ? _c("UcPaymentTransactionTypeSymbol", {
                        staticClass: "mx-2",
                        attrs: { transactionType: _vm.payment.transaction_type }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("ItpText", {
                staticClass: "mb-0",
                attrs: { tag: "h4", text: _vm.resourceKey }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "DIV",
            { staticClass: "btn-toolbar ml-auto flex-nowrap" },
            [
              !_vm.isNew
                ? _c("ItpButton", {
                    staticClass: "ml-auto mr-2",
                    attrs: {
                      icon: "fa-sync-alt",
                      tooltip: _vm._f("gettext")("Reload"),
                      spinning: _vm.actions.reload.isRunning,
                      variant: "light"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_1040167445267876_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isNew
                ? _c("BtnSyncResource", {
                    staticClass: "ml-auto mr-2",
                    attrs: {
                      resource: _vm.payment,
                      target: "irent",
                      confirmMessage:
                        "A tranzakciót csak egyszer lehet felölteni a régi rendszerbe,\nfeltöltés után a tranzakciót már nem lehet módosítani."
                    },
                    on: {
                      success: function($event) {
                        return _vm.evh_4186377094414664_success($event, {})
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.payment.meta && _vm.payment.meta.preview_url
                ? _c("ItpButton", {
                    staticClass: "ml-auto mr-2",
                    attrs: {
                      variant: "light",
                      icon: "icon-park-outline:preview-open",
                      href: _vm.payment.meta.preview_url,
                      tooltip: _vm._f("pgettext")("Open preview", "Payment"),
                      target: "_blank",
                      "use-auth": "",
                      "show-spinner": ""
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isNew
                ? _c(
                    "b-dropdown",
                    {
                      staticClass: "border",
                      attrs: { right: "", variant: "light" }
                    },
                    [
                      _c("ItpIcon", {
                        staticClass: "mx-1",
                        attrs: { slot: "button-content", fa: "bars" },
                        slot: "button-content"
                      }),
                      _vm._v(" "),
                      !_vm.isNew && !_vm.payment.isReadonly
                        ? _c("ItpButton", {
                            staticClass: "mr-2",
                            attrs: {
                              text: _vm._f("pgettext")("Complete", "Command"),
                              disabled: !_vm.isNew && _vm.payment.readonly,
                              variant: "success",
                              "dropdown-item": "",
                              icon: "fa-check"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.evh_1506888955587522_clickPreventStop(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isNew
                        ? _c("BtnDeleteResource", {
                            attrs: {
                              "no-icon": "",
                              "dropdown-item": "",
                              resource: _vm.payment,
                              tooltip: _vm._f("pgettext")(
                                "Delete payment",
                                "Payment"
                              ),
                              disabled: _vm.payment.isReadonly
                            },
                            on: {
                              success: function($event) {
                                return _vm.evh_3306541085110264_success(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }